<div
  class="qaroni-title-dashboard-container flex flex-col justify-end sm:flex-row sm:justify-between">
  <div class="flex-1">
    <div class="flex flex-row items-center">
      <span class="qaroni-title-dashboard mb-0 me-2">
        <ng-content select="[title]" />
      </span>
      <ng-content select="[action]" />
    </div>
  </div>
  <div
    class="flex flex-col items-end justify-end gap-2 sm:items-center sm:justify-center lg:flex-row">
    <ng-content select="[button]" />
    <ng-content select="[secondary-button]" />
    <ng-content select="[export]" />
  </div>
</div>
